/** Portfolio maker API routes (backend routes/portfolio.py). */
const segment = (value) => encodeURIComponent(value);

export const PORTFOLIO = Object.freeze({
  OVERVIEW: '/teacher/portfolio',
  SITE: '/teacher/portfolio/site',
  PAGES: '/teacher/portfolios',
  PAGE: (id) => `/teacher/portfolios/${segment(id)}`,
  PUBLISH: (id) => `/teacher/portfolios/${segment(id)}/publish`,
  UNPUBLISH: (id) => `/teacher/portfolios/${segment(id)}/unpublish`,
  MEDIA: '/teacher/portfolio-media',
  PRIVATE_MEDIA: (id) => `/teacher/portfolio-media/${segment(id)}`,
  PUBLIC: (host, subject = '') => `/public/portfolios/${segment(host)}${subject ? `/${segment(subject)}` : ''}`,
  PUBLIC_MEDIA: (id) => `/public/portfolio-media/${segment(id)}`,
});
